import React from 'react';
import { useNavigate, Routes, Route } from 'react-router-dom';
import RequestList from './RequestList';
import RequestDetails from './RequestDetails';
import RequestForm from './RequestForm';
import './AdminRequests.css';

const AdminRequests = () => {
  const navigate = useNavigate();
  
  // Function to handle adding a new request
  const handleAddRequest = () => {
    navigate('/admin/dashboard/requests/form');
  };

  return (
    <div className="admin-requests-container">
      <div className="admin-requests-header">
        <h1>Request Management</h1>
        <button 
          className="add-request-btn"
          onClick={handleAddRequest}
        >
          Add New Request
        </button>
      </div>
      
      {/* Routes for request management */}
      <Routes>
        <Route index element={<RequestList />} />
        <Route path="details/:id" element={<RequestDetails />} />
        <Route path="form" element={<RequestForm />} />
        <Route path="form/:id" element={<RequestForm />} />
      </Routes>
    </div>
  );
};

export default AdminRequests;